import Container from './sold-card-container';

export default Container;
